import type { SidebarOutput } from '@sysarb/sysarb-types-v2/services/v1/analytics';
import type { useResgate } from '@/login/composables/useResgate';
import { useLoginStore } from '@/login/stores/useLoginStore';

export class PayEquityAnalysis {
    private readonly abortControllers: Map<string, AbortController[]> = new Map();

    /**
     * Fetches suggestions for mixMax values
     */
    public getOperationalAdministratorMappings(resgate: ReturnType<typeof useResgate>, orgNodeId: string, userId: string): Promise<SidebarOutput[] | null> | null {
        const data = {
            orgNodeId,
            userId
        };
        const { instanceTopic } = useLoginStore();
        if (instanceTopic == null) return null;
        return resgate.call<SidebarOutput[]>(`salary-mapping.v1.${instanceTopic}`, 'sidebar', data).then(res => {
            if (res?.success === false) return null;
            return res.data;
        });
    }
}
